import { Filter } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigation } from "@refinedev/core";
import { FC } from "react";

export const PaymentModeButton: FC<{
  from: string;
  to: string;
}> = ({ from, to }) => {
  const { push } = useNavigation();
  const handleClick = () => {
    push(`/receipts/payment?from=${from}&to=${to}`);
  };

  return (
    <Button
      startIcon={<Filter />}
      onClick={handleClick}
      disabled={!to || !from}
      size="large"
      color="secondary"
    >
      Payment mode
    </Button>
  );
};
